<template>
  <div>
    <FDBannerImg />
    <div class="navigation">
      <div class="page-cen">
        <div class="navigation-item">
          <a href="javascript:void(0)" @click="goPage('/home')">首页</a
          >&nbsp;&gt;
          <a class="active" href="javascript:void(0)">期刊</a>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="tag">
        <div
          :class="tag == item ? 'tag_item active_tag' : 'tag_item'"
          v-for="(item, index) in tagList"
          :key="item"
          @click="selectTag(item, index)"
        >
          {{ item }}
        </div>
        <div class="search_box">
          <el-input
            v-model="title"
            style="width: 250px; margin-right: 10px"
            placeholder="请输入期刊名称"
            size="small"
            clearable
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="onSearch"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="small" @click="onRefresh"
            >重置</el-button
          >
        </div>
      </div>
      <div class="content">
        <div class="content_list" v-if="total > 0">
          <el-table :data="dataList" stripe style="width: 100%">
            <el-table-column prop="title" label="期刊名称" />
            <el-table-column prop="periods" label="全年期数" width="180" />
            <el-table-column prop="level" label="等级" width="180" />
          </el-table>
          <Pagination
            v-if="total > 0"
            :total="total"
            :page.sync="currentPage"
            :limit.sync="pageSize"
            @pagination="handleCurrentChange"
          />
        </div>
        <div v-if="total == 0" class="empty">
          <img src="../../assets/empty.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import FDBannerImg from "@c//FDBannerImg";

import { post, get } from "@u/request";

export default {
  name: "",
  components: { Pagination, FDBannerImg },
  data() {
    return {
      logo: "",
      copyright: {},
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dataList: [],
      tag: "",
      tagIndex: 0,
      tagList: [],
      title: "",
    };
  },
  computed: {
    // 缓存页面name
    catche() {
      return this.$store.getters.includeArr;
    },
    key() {
      return this.$router.fullPath;
    },
  },
  methods: {
    selectTag(item, index) {
      this.tag = item;
      this.tagIndex = index;
      this.title = "";
      this.loadList();
    },
    handleCurrentChange() {
      this.loadList();
    },
    onSearch() {
      this.currentPage = 1;
      this.loadList();
    },
    onRefresh() {
      this.title = "";
      this.onSearch();
    },
    // toDetail(item) {
    //   this.$router.push(`/news/detail/${item.id}`);
    // },
    async loadList() {
      const params = {
        status: 1,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        menuId: 10023,
        title: this.title,
      };
      params.type = this.tagIndex;
      const { rows, total } = await get("lib/periodical/list", params).catch(
        () => {}
      );
      this.dataList = rows;
      this.total = total;
    },
    goPage(url) {
      this.$router.push(url);
    },
    async getDegreeType() {
      let { data } = await get("system/dict/data/getList", {
        dictType: "journal_type",
      }).catch(() => {});
      data = data.map((item) => item.dictLabel);
      this.tag = data[0];
      this.tagList = data;
    },
  },
  created() {
    this.getDegreeType();
    this.loadList();
  },
};
</script>

<style scoped lang="scss">
.banner_img {
  height: 220px;
  overflow: hidden;
  position: relative;
  img {
    // position:absolute;
    // top: -200px;
    // height: 600;
    // width: 100%;
  }
}
.container {
  width: 1200px;
  margin: 20px auto;
  padding-bottom: 96px;
  .tag {
    display: flex;
    .tag_item {
      cursor: pointer;
      border: 1px solid #cdcdcd;
      background: #fff;
      font-size: 12px;
      color: #525252;
      line-height: 30px;
      padding: 0 18px;
      margin-right: 10px;
      border-radius: 20px;
    }
    .tag_item:hover,
    .active_tag {
      background-color: #004796;
      color: #fff;
    }
  }
  .search_box {
    margin-left: 30px;
  }
  .content {
    padding-top: 10px;
    .empty {
      text-align: center;
    }
    .content_list {
      margin-bottom: 80px;
      .list_item:hover {
        color: #004796;
      }
      .list_item {
        cursor: pointer;
        position: relative;
        display: flex;
        padding: 20px 0;
        border-bottom: 1px solid #dadada;
        color: #121212;
        .keyword {
          position: absolute;
          right: 100px;
          font-size: 12px;
          border-radius: 30px;
          min-width: 70px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          padding: 0 5px;
          border: 1px solid #cdcdcd;
          background: #fff;
          color: #525252;
        }
        .date {
          position: absolute;
          right: 0;
          color: #999;
          font-size: 14px;
        }
        // .color1 {
        //   background: #eff1ff;
        //   color: #0309b8;
        // }
        // .color2 {
        //   background: #d8ffff;
        //   color: #306eb4;
        // }
        // .color3 {
        //   background: #f6eeff;
        //   color: #82318e;
        // }
        // .color4 {
        //   background: #eee;
        //   color: #878787;
        // }
      }
    }
  }
}
</style>
